// "husky": {
//   "hooks": {
//     "pre-commit": "lint-staged"
//   }
// }

import React from 'react';
import { Switch, Route } from 'react-router-dom';
import AuthPage from './pages/auth/auth.page';
import DesignPage from './pages/design/design.page';
import ConfirmPage from './pages/confirm/confirm.page';
import NotFoundPage from './pages/notFound/notFound.page';
import DemoPage from './pages/demo/demo.page';
import InvitePage from './pages/invite/invite.page';
import CompletePage from './pages/complete/complete.page';
import ProgramInvitePage from './pages/program-invitation/programInvite.page';
import BuyCreditComponent from './components/buyCredits/buyCredits.component';
import NavbarComponent from './components/navbar/navbar.component';
import TabViewPage from './pages/tabview/tabView.page';
import SchedulePage from './pages/schedule/schedule.page';
import EmbedPage from './pages/embed/embed.page';
import MyProgramsPage from './pages/programs/program.page';
import HomePage from './pages/home/home.page';
import EditDesignPage from './pages/edit-design/editDesign.page';
import PaymentPage from './pages/payment/payment.page';
import { useTokenStore } from './store';
import SignOut from './pages/SignOut';
import { useUserInfo } from './services';

const App = () => {
  const hasToken = useTokenStore((s) => !!s.accessToken);
  useUserInfo();

  const routes = (
    <Switch>
      <Route path="/">
        {!hasToken ? (
          <AuthPage />
        ) : (
          <Switch>
            <Route path="/" exact component={HomePage} />
            <Route path="/embed" exact component={EmbedPage} />
            <Route path="/my-programs" exact component={MyProgramsPage} />
            <Route path="/design/:action/:id" exact component={DesignPage} />
            <Route path="/schedule/:action/:id" exact component={SchedulePage} />
            <Route path="/edit-design" exact component={EditDesignPage} />
            <Route path="/not-found" exact component={NotFoundPage} />
            <Route path="/confirm" exact component={ConfirmPage} />
            <Route path="/demo" exact component={DemoPage} />
            <Route path="/invite/:action" exact component={InvitePage} />
            <Route path="/complete" exact component={CompletePage} />
            <Route path="/payment" exact component={PaymentPage} />
            <Route path="/program-invite" exact component={ProgramInvitePage} />
            <Route path="/profile" exact component={TabViewPage} />
            <Route path="/settings" exact component={TabViewPage} />
            <Route path="/resources" exact component={TabViewPage} />
            <Route path="/transactions" exact component={TabViewPage} />

            <Route path="/buy-credits" exact component={BuyCreditComponent} />
            <Route path="/signout" exact component={SignOut} />

            <Route path="*" component={NotFoundPage} />
          </Switch>
        )}
      </Route>
    </Switch>
  );

  return (
    <div>
      <NavbarComponent />
      {routes}
    </div>
  );
};

export default App;
